import I18n from 'I18n';
import http from 'hub-http/clients/apiClient';
import { CONTAINER_TYPES } from 'web-interactives-data/constants/ContainerConstants';
const CONTENT_URL = 'web-interactives/v1/cos-interactives';
export const deleteInteractive = id => {
  return http.delete(`${CONTENT_URL}/${id}`);
};
export const cloneInteractive = (id, name) => {
  return http.post(`${CONTENT_URL}/${id}/clone`, {
    data: {
      name
    }
  });
};
export const archiveInteractives = (ids, shouldArchive = false) => {
  const archivePath = shouldArchive ? 'archive-and-unpublish' : 'archive';
  return http.put(`${CONTENT_URL}/${archivePath}?${ids.map(id => `id=${id}`).join('&')}`, {
    data: {
      isArchived: shouldArchive
    }
  });
};
export const unpublishInteractive = id => http.postWithResponse(`${CONTENT_URL}/${id}/publish-action`, {
  data: {
    action: 'cancel-publish'
  }
});
export const createInteractive = (templatePath, createdFromIlsListId) => {
  const data = {
    templatePath
  };
  if (createdFromIlsListId) {
    data.createdFromIlsListId = createdFromIlsListId;
  }
  return http.post(CONTENT_URL, {
    data
  });
};

// temporary, remove when we are redirecting to a creation flow
export const createDefaultInteractive = (interactiveContainerType = CONTAINER_TYPES.MODAL) => http.post(CONTENT_URL, {
  data: {
    name: I18n.text(`app.newModel.${interactiveContainerType}`),
    interactiveContainerType
  }
});
export const getAbTestData = abTestId => {
  return http.get(`${CONTENT_URL}/ab-test-variants/${abTestId}`);
};
export const createVariation = (id, variantName) => {
  return http.post(`${CONTENT_URL}/${id}/create-variation`, {
    data: {
      variantName
    }
  });
};
export const endTestWithWinner = (abTestId, winnerId) => {
  return http.post(`${CONTENT_URL}/end-ab-test/${abTestId}`, {
    data: winnerId
  }).then(() => true).catch(error => {
    console.error('Error ending test with winner:', error);
    return false;
  });
};
export const PERMISSION_TYPE = {
  TEAM: 'TEAM',
  USER: 'USER'
};
export const assignPermissions = (ids, data) => {
  const permissions = {
    [PERMISSION_TYPE.USER]: data.users,
    [PERMISSION_TYPE.TEAM]: data.teams
  };
  return http.put(`${CONTENT_URL}/assign-permissions`, {
    data: {
      objectIds: ids,
      permissionRefIdsByType: permissions
    }
  });
};